import { gql } from '@apollo/client';

// NOTE: Only exists on api's `fdic` branch.
export const ACKNOWLEDGE_SALE_DOCUMENT = gql`
  mutation AcknowledgeSaleDocument(
    $saleId: ID!
    $docType: SaleDocumentType!
    $version: String!
    $documentSha256: String!
    $title: String
    $relationship: SaleAcknowledgementRelationship
  ) {
    acknowledgeSaleDocument(
      sale_id: $saleId
      doc_type: $docType
      version: $version
      document_sha256: $documentSha256
      title: $title
      relationship: $relationship
    ) {
      __typename
      sale_id
      status
      approved
      level
      access_cutoff_at
      download_period_hours
      acknowledgements {
        doc_type
        version
        accepted_at_milliseconds
      }
    }
  }
`;
